/*
 * @Description: 权限
 * @Author: ZY
 * @Date: 2020-12-28 09:12:46
 * @LastEditors: fugang
 * @LastEditTime: 2022-05-11 14:30:19
 */

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import router from '@/router'
import { RouteLocationNormalized } from 'vue-router'
import { useStore } from './store'
import { UserActionTypes } from './store/modules/user/action-types'
import { PermissionActionType } from './store/modules/permission/action-types'
import { ElMessage } from 'element-plus'
import whiteList from './config/default/whitelist'

NProgress.configure({ showSpinner: false })

function needRefreshRoutes(store: ReturnType<typeof useStore>) {
  const cachedRole = localStorage.getItem('systempremmsion') ?? ''
  const cachedLoginId = localStorage.getItem('loginId') ?? ''
  const { loadedRole, loadedLoginId } = store.state.permission
  return cachedRole !== loadedRole || cachedLoginId !== loadedLoginId
}

router.beforeEach(async (to: RouteLocationNormalized, _: RouteLocationNormalized, next: any) => {
  NProgress.start()
  const store = useStore()
  if (localStorage.getItem('token')) {
    if (to.path === '/login') {
      next()
      NProgress.done()
    } else if (needRefreshRoutes(store)) {
      try {
        await store.dispatch(PermissionActionType.ACTION_GENERATE_ROUTES, undefined)
        next({ ...to, replace: true })
      } catch (err) {
        store.dispatch(UserActionTypes.ACTION_RESET_TOKEN, undefined)
        const message =
          err instanceof Error
            ? err.message
            : typeof err === 'string'
              ? err
              : '获取用户信息失败'
        ElMessage.error(message || '获取用户信息失败')
        next(`/login?redirect=${to.path}`)
        NProgress.done()
      }
    } else {
      next()
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach((to: RouteLocationNormalized) => {
  NProgress.done()
})
